import { createContext } from "react";

/**
 * GMA-1909 — the ticking half of the session state, deliberately separate from
 * AuthContext.
 *
 * The countdown changes once a second. AuthContext is consumed by large pages
 * (ClientCalendar, SelectClientHomepage), so publishing the tick there made an
 * idle session re-render the whole app continuously — a performance regression
 * caused by the feature that is supposed to be doing nothing while idle.
 *
 * Only the clock reads this. Everything stable about the session — the user,
 * the auth flags, `logout`, `resetSessionDeadline` — stays on AuthContext.
 */
export const SessionCountdownContext = createContext({
  remainingMs: null,
  isWarning: false,
});

export default SessionCountdownContext;
